import { useState, useEffect } from 'react';

export const useIsRTL = () => {
  const [isRTL, setIsRTL] = useState<boolean>(false);
  useEffect(() => {
    const rtlCB = () => {
      setIsRTL(document.querySelector('body')?.getAttribute('dir') === 'rtl');
    };
    const observer = new MutationObserver(rtlCB);
    const bodyElement = document.querySelector('body');
    if (bodyElement) {
      observer.observe(bodyElement, { attributes: true });
    }
    rtlCB();
    return () => {
      observer.disconnect();
    };
  }, []);
  return { isRTL };
};
